/* Brightwell Theme*/

import { CSSObjectWithLabel, StylesConfig } from "react-select";

export const COLORS = {
  WHITE: "#FFFFFF",
  BELUGA_WHITE: "#EDEFF2",
  INTERACTIVE_BLUE: "#1C74D9",
  SHARK_GREY: "#8994A6",
  SKY_GREY: "#C5D0DE",
  TEXT_PRIMARY: "#181D25",
};

const FONT_SIZES = {
  DEFAULT: "14px",
  DROPDOWN_VALUE_LINE_HEIGHT: "16px",
};

export const DROPDOWN_STYLES: StylesConfig<any, false> = {
  container: (styles) => ({
    ...styles,
    lineHeight: FONT_SIZES.DEFAULT,
  }),
  menu: (styles) => {
    return {
      ...styles,
      zIndex: "9000",
    };
  },
  menuList: (styles) => {
    return {
      ...styles,
      maxHeight: 300,
    };
  },
  control: (styles, { isFocused }) => ({
    ...styles,
    borderColor: isFocused ? COLORS.INTERACTIVE_BLUE : COLORS.SKY_GREY,
    minHeight: 0,
    padding: "6px 12px",
    boxShadow: "none",
    "&:hover": {
      borderColor: isFocused ? COLORS.INTERACTIVE_BLUE : COLORS.SKY_GREY,
    },
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: isSelected
      ? COLORS.SKY_GREY
      : isFocused
        ? COLORS.BELUGA_WHITE
        : COLORS.WHITE,
    color: isDisabled ? COLORS.SHARK_GREY : COLORS.TEXT_PRIMARY,
    fontWeight: "bold",
  }),
  singleValue: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled ? COLORS.SKY_GREY : COLORS.TEXT_PRIMARY,
    fontWeight: "bold",
    padding: 0,
    lineHeight: FONT_SIZES.DROPDOWN_VALUE_LINE_HEIGHT,
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: 0,
  }),
  input: (styles: CSSObjectWithLabel, state) => ({
    ...styles,
    color: state.isDisabled ? COLORS.SKY_GREY : COLORS.TEXT_PRIMARY,
    padding: 0,
    margin: 0,
    fontWeight: "bold",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (styles: CSSObjectWithLabel, state) => ({
    ...styles,
    color: state.isDisabled ? COLORS.SKY_GREY : COLORS.TEXT_PRIMARY,
    padding: 0,
    "&:hover": {
      color: state.isDisabled ? COLORS.SKY_GREY : COLORS.TEXT_PRIMARY,
    },
  }),
  clearIndicator: (styles) => ({
    // this is the 'x' right aligned on a dropdown when a value is selected.
    ...styles,
    padding: "0px 5px 0px 0px",
  }),
  placeholder: (styles, { isDisabled }) => {
    return {
      ...styles,
      color: isDisabled ? COLORS.SKY_GREY : COLORS.TEXT_PRIMARY,
      fontWeight: "bold",
    };
  },
};
